import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { CopyService } from '@amfam/shared/utility/shared-services';
import { CircleProgressOptionsInterface, ValidationService } from '@amfam/ui-kit';

import { PhotoThumbnail } from '../../models/photo-thumbnail';

@Component({
  selector: 'ds-claim-photo',
  templateUrl: './claim-photo.component.html',
  styleUrls: ['./claim-photo.component.scss'],
  standalone: false
})
export class ClaimPhotoComponent implements OnInit {
  @Input() thumbnail: PhotoThumbnail;
  @Input() missingData: boolean;
  @Output() removePhotoEvent = new EventEmitter();
  @Output() retryUploadEvent = new EventEmitter();
  @Output() inputChangeEvent = new EventEmitter();

  categoryOptions: string[];

  public progressIndicatorOptions: CircleProgressOptionsInterface = {
    percent: 0,
    radius: 8,
    strokeWidth: 3
  };

  selectCategory: AbstractControl;
  inputDescription: AbstractControl;
  showDescription = false;
  form: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private copyService: CopyService
  ) {}

  ngOnInit() {
    this.categoryOptions = this.copyService.get('claims', 'photoUpload').photoListCategories;

    this.form = this.formBuilder.group({
      selectCategory: ['', Validators.compose([Validators.required])],
      inputDescription: ['', Validators.compose([ValidationService.photoUploadTextAreaInput])]
    });
    this.selectCategory = this.form.controls['selectCategory'];
    this.inputDescription = this.form.controls['inputDescription'];
  }

  // TODO: Handle retry upload
  retryUpload() {
    this.retryUploadEvent.emit(this.thumbnail);
  }

  // Update thumbnail model with new category.
  onCategoryChange() {
    this.thumbnail.category = this.selectCategory.value;
    this.inputChangeEvent.emit(this.thumbnail);
  }

  // Update thumbnail model with new description changes.
  onDescriptionChange() {
    this.thumbnail.description = this.inputDescription.value;
    this.inputChangeEvent.emit(this.thumbnail);
  }

  // Show description text box
  addDescription() {
    this.showDescription = true;
  }

  // Hide description text box and remove existing value
  removeDescription() {
    this.showDescription = false;
    this.inputDescription.setValue('');
  }

  // Emit to parent list to remove photo
  remove() {
    this.removePhotoEvent.emit(this.thumbnail);
  }
}
